$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang || 'fi';
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
        case "et":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language, "X-Prefix": prefix },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-varha-webinaari/",
        uri: "/fi/tulkkaus/ajankohtaista/varha-tekoalytulkkaus-kokemuksia/"
    };

    $("#webinarForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#webinarForm')[0].checkValidity()) {
            $("#webinarSendBtn").prop("disabled", true);
            $("#webinarSendBtn").css("background-color", "#6c757d");
            $("#webinarSendBtn").text("Lähetetään...");

            let firstName = $("#webinarFirstName").val();
            let lastName = $("#webinarLastName").val();
            let email = $("#webinarEmail").val();
            let organization = $("#webinarOrganization").val() || "";

            let selectedSector = $("input[name='sector']:checked").val() || "";
            if (selectedSector === "Muulla alalla millä?" && $("#webinarSectorOther").val()) {
                selectedSector = `Muulla alalla: ${$("#webinarSectorOther").val()}`;
            }

            let userMessage = $("#webinarMessage").val() || "";

            let additionalInfoParts = [];
            if (organization) {
                additionalInfoParts.push(`Organisaatio: ${organization}`);
            }
            if (selectedSector) {
                additionalInfoParts.push(`Työskentelen: ${selectedSector}`);
            }
            if (userMessage) {
                additionalInfoParts.push(`Kysymys/kommentti asiantuntijoille: ${userMessage}`);
            }

            let additionalInformation = additionalInfoParts.join('\n\n');

            let code = "";
            if ($('#webinarNewsletterCheckbox').is(':checked')) {
                code = "newsletter";
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: additionalInformation,
                competitionName: "Varha webinar",
                uri: Uris.uri,
                languageCode: language,
                code: code
            };

            getRecaptchaToken().then(function (token) {
                if (token) {
                    data.recaptchaToken = token;
                }
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#webinarSendBtn").prop("disabled", false);
                    $("#webinarSendBtn").css("background-color", "#48a627");
                    $("#webinarSendBtn").text("Ilmoittaudu webinaariin");
                });
            });
        } else {
            $('#webinarForm')[0].reportValidity();
        }
    });

    // Show/focus other sector input when selected
    $("input[name='sector']").on("change", function () {
        if ($("#webinarSectorOtherRadio").is(":checked")) {
            $("#webinarSectorOther").slideDown().focus();
        } else {
            $("#webinarSectorOther").slideUp();
        }
    });

    // Function to toggle button state based on form validity
    function toggleSendButtonState() {
        const formValid = $('#webinarForm')[0].checkValidity();

        if (formValid) {
            $("#webinarSendBtn").prop("disabled", false);
            $("#webinarSendBtn").css("background-color", "#48a627");
        } else {
            $("#webinarSendBtn").prop("disabled", true);
            $("#webinarSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger button state change on input changes
    $('#webinarForm input, #webinarForm textarea').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});
